"use client";

import { useState } from "react";
import { useTranslation } from "next-i18next";
import { Search } from "@mui/icons-material";
import useGeneralStore from "@/store/General/useGeneralStore";
import BlogCard from "./BlogCard";
import BlogCardSkeleton from "@/skeletons/BlogCardSkeleton";

const BlogsComponent = () => {
  const { t, i18n } = useTranslation("common");
  const isRtl = i18n.language === "ar";
  const { BlogsComponent: blogsData, isLoadingBlogsComponent } =
    useGeneralStore((state) => ({
      BlogsComponent: state.BlogsComponent,
      isLoadingBlogsComponent: state.isLoadingBlogsComponent,
    }));

  const [searchQuery, setSearchQuery] = useState("");

  const blogs = blogsData || [];
  const isLoading = isLoadingBlogsComponent;

  const filteredBlogs = blogs.filter(
    (blog) =>
      blog.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      blog.description?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <div dir={isRtl ? "rtl" : "ltr"} lang={i18n.language} className="bg-white">
      <div className="max-w-[120rem] mx-auto px-[1rem] md:px-[2rem] py-[3rem] md:py-[5rem]">
        <h1 className="text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-tertiary text-center mb-[2rem]">
          {t("news.title")}
        </h1>
        {/* Search Bar */}
        <div className="mb-[3rem]">
          <div className="relative max-w-[36rem] mx-auto">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder={t("news.searchPlaceholder")}
              aria-label={t("news.searchPlaceholder")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-[0.75rem] focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        {/* Blogs Grid */}
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1.5rem] md:gap-[2rem]">
            <BlogCardSkeleton count={6} />
          </div>
        ) : filteredBlogs.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[1.5rem] md:gap-[2rem]">
            {filteredBlogs.map((blog) => (
              <BlogCard key={blog.id} blog={blog} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">
              {t("blogsPage.noBlogsFound")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogsComponent;
